// admin/* page translations
const admin = {
  index: {
    title: 'Trang quản trị',
    subtitle: 'Quản lý công ty và dữ liệu',
    tab: {
      company: 'Quản lý công ty',
      data: 'Kiểm tra dữ liệu',
    },
  },
  companyManagement: {
    statusLabel: 'Trạng thái',
    statusAll: 'Tất cả',
    statusActive: 'Hoạt động',
    statusInactive: 'Vô hiệu',
    searchPlaceholder: 'Tìm tên hoặc mã công ty',
    addBtn: 'Thêm công ty',
    col: {
      name: 'Tên công ty',
      code: 'Mã công ty',
      ceo: 'Giám đốc',
      businessNumber: 'Mã số kinh doanh',
      address: 'Địa chỉ',
      phone: 'Điện thoại',
      employees: 'Nhân viên',
      status: 'Trạng thái',
      createdDate: 'Ngày đăng ký',
      action: 'Thao tác',
    },
    employeesSuffix: '{n}',
    stats: {
      total: 'Tổng công ty',
      active: 'Hoạt động',
      inactive: 'Vô hiệu',
      employees: 'Tổng nhân viên',
    },
    deleteModal: {
      title: 'Xác nhận xóa công ty',
      messagePrefix: 'Bạn có chắc muốn xóa công ty này?',
      submessage: 'Hành động này không thể hoàn tác.',
      cancel: 'Hủy',
      confirm: 'Xóa',
    },
  },
  companyRegister: {
    title: 'Đăng ký công ty',
    subtitle: 'Đăng ký thông tin công ty mới',
    sectionBasic: 'Thông tin cơ bản',
    sectionContact: 'Thông tin liên hệ',
    sectionOperation: 'Thông tin vận hành',
    fields: {
      name: 'Tên công ty',
      code: 'Mã công ty',
      ceo: 'Giám đốc',
      businessNumber: 'Mã số kinh doanh',
      address: 'Địa chỉ',
      phone: 'Điện thoại',
      employees: 'Nhân viên',
      status: 'Trạng thái',
    },
    placeholder: {
      name: 'Nhập tên công ty',
      code: 'Nhập mã công ty',
      ceo: 'Nhập tên giám đốc',
      businessNumber: '123-81-00998',
      address: 'Nhập địa chỉ',
      phone: '031-200-1114',
      employees: 'Nhập số nhân viên',
    },
    statusActive: 'Hoạt động',
    statusInactive: 'Vô hiệu',
    cancel: 'Hủy',
    submit: 'Đăng ký',
    error: {
      nameRequired: 'Vui lòng nhập tên công ty',
      codeRequired: 'Vui lòng nhập mã công ty',
      ceoRequired: 'Vui lòng nhập tên giám đốc',
      businessNumberRequired: 'Vui lòng nhập mã số kinh doanh',
      businessNumberInvalid: 'Định dạng mã số kinh doanh không hợp lệ (VD: 123-81-00998)',
      addressRequired: 'Vui lòng nhập địa chỉ',
      phoneRequired: 'Vui lòng nhập số điện thoại',
      phoneInvalid: 'Định dạng điện thoại không hợp lệ (VD: 031-200-1114)',
      employeesRequired: 'Vui lòng nhập số nhân viên',
      employeesInvalid: 'Vui lòng nhập số nhân viên hợp lệ',
    },
  },
  companyDetail: {
    title: 'Chi tiết công ty',
    subtitle: 'Xem và sửa thông tin công ty',
    delete: 'Xóa',
    edit: 'Sửa',
    cancel: 'Hủy',
    save: 'Lưu',
    profile: {
      codeLabel: 'Mã công ty: {code}',
      registeredOn: 'Ngày đăng ký',
      employees: 'Nhân viên',
    },
    sectionBasic: 'Thông tin cơ bản',
    sectionContact: 'Thông tin liên hệ',
    sectionOperation: 'Thông tin vận hành',
    fields: {
      name: 'Tên công ty',
      code: 'Mã công ty',
      ceo: 'Giám đốc',
      businessNumber: 'Mã số kinh doanh',
      address: 'Địa chỉ',
      phone: 'Điện thoại',
      employees: 'Nhân viên',
      status: 'Trạng thái',
      createdDate: 'Ngày đăng ký',
    },
    statusActive: 'Hoạt động',
    statusInactive: 'Vô hiệu',
    employeesSuffix: '{n}',
    confirmDelete: 'Bạn có chắc muốn xóa công ty này?',
  },
  dataVerification: {
    placeholder: 'Đang phát triển',
  },
};

export default admin;
